import { Button, Col, Row, Spinner } from "react-bootstrap";
import FormInputValidationMessage from "../../../../components/forminputvalidationmessage";
import { useForm } from "react-hook-form";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";

const PdsForm = ({TargetId = null,initialValues,onSubmit,isSubmitting,endReasons = [],relationships = [],states = [],pdsEntries = [],deselect}) => {
    const _isOverlapping = ({startDate,endDate},entries = [],editingId = null) => {
            const newStart = new Date(startDate);
            const newEnd = endDate ? new Date(endDate) : new Date("9999-12-31");
    
            return entries.some(({id,startDate: existingStart,endDate: existingEnd}) => {
                if(id === editingId) return false;
    
                const existingStartDate = new Date(existingStart);
                const existingEndDate = existingEnd ? new Date(existingEnd) : new Date("9999-12-31");
    
                return newStart <= existingEndDate && existingStartDate <= newEnd;
    
            });
        }
        
    
        const validationSchema = Yup.object().shape({
            startDate: Yup.string().required('*Required')
            .test('no-overlap','This date range overlaps with an existing one.',function(value){
                    const {endDate} = this.parent;
    
                    if(!endDate) return true;
    
                    return !_isOverlapping({startDate: value,endDate},pdsEntries,TargetId);
                }),
            endDate: Yup.string().nullable()
                .test('endRequiredWhenReason','End Date is required when supplying and End Reason',function(value) {
                    const {endReason} = this.parent;
    
                    if(endReason === '') return true;
    
                    return value !== '';
                })
                .test('no-overlap','This date range overlaps with an existing one.',function(value){
                    const {startDate} = this.parent;
    
                    if(!startDate) return true;
    
                    return !_isOverlapping({startDate,endDate: value},pdsEntries,TargetId);
                })
                .test('valid-end','End date must be after or on start date',function(value){
                    const {startDate} = this.parent;
    
                    if(!value || !startDate) return true;
    
                    return new Date(value) >= new Date(startDate)
            }),
            endReason: Yup.string().when('endDate',{
                is: (val) => val !== null && val !== '',
                then: (schema) => schema.required("End Reason is required when supplying an End Date."),
                otherwise: (schema) => schema.notRequired()
            }),
            endReasonOther: Yup.string().when('endReason',{
                is: (val) => endReasons.find(item => item.id === val)?.hasfollowup,
                then: (schema) => schema.required("*Required"),
                otherwise: (schema) => schema.notRequired()
            })
        });
    
    const {handleSubmit,register,watch,resetField,reset,formState: {isDirty,errors}} = useForm({defaultValues: initialValues,resolver: yupResolver(validationSchema)});

    const endReasonval = watch('endReason');
    
        const selectedEndReason = endReasons.find(item => item.id === endReasonval);
    
        useEffect(() => {
            if(!TargetId){
                //Only reset in add mode
                if(selectedEndReason){
                    if(selectedEndReason.hasfollowup){
                        resetField('endReasonOther',{defaultValue: ''});
                    }
                }
                else{
                    resetField('endReasonOther',{defaultValue: ''});
                }
            }
        },[selectedEndReason,TargetId,resetField])
        
    
        const requiredOtherEndReason = endReasonval !== ''
        ?
            endReasons.find(item => item.id === endReasonval)?.hasfollowup
        :
            false

    
            useEffect(() => {
                const resetObj = {
                    ...initialValues,
                    representativeState: `${initialValues.representativeState}`
                }

                reset(resetObj);
            },[initialValues,reset])

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <input type='hidden' {...register('id')} />
                <Row>
                                            <Col xs={12} md={6} lg={4}>
                                                <Row>
                                                    <Col xs={12}>
                                                        <label htmlFor='participationstartdate'>Participation Start Date</label>
                                                        <input type='date' id='participationstartdate' style={{width: '100%',height: '30px'}} {...register('startDate')} />
                                                        {
                                                            errors.startDate
                                                            &&
                                                            <FormInputValidationMessage error={errors?.startDate} />
                                                        }
                                                    </Col>
                                                    <Col xs={12}>
                                                        <label htmlFor='participationenddate'>Participation End Date</label>
                                                        <input type='date' id='participationenddate' style={{width: '100%',height: '30px'}} {...register('endDate')}/>
                                                        <FormInputValidationMessage error={errors?.endDate} />
                                                    </Col>
                                                    <Col xs={12}>
                                                        <label htmlFor='endreason'>End Reason</label>
                                                        <select id='endreason' style={{width: '100%',height: '30px'}} {...register('endReason')}>
                                                            <option value=''>--Select End Reason--</option>
                                                            {
                                                                endReasons.map((item) => (
                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <FormInputValidationMessage error={errors?.endReason} />
                                                    </Col>
                                                    {
                                                        requiredOtherEndReason &&
                                                        <Col xs={12}>
                                                            <label htmlFor='endreasonother'>End Reason Other</label>
                                                            <input type='text' id='endreasonother' style={{width: '100%'}} {...register('endReasonOther')}/>
                                                            <FormInputValidationMessage error={errors?.endReasonOther} />
                                                        </Col>
                                                    }
                                                    <Col xs={12}>
                                                        <label>
                                                            <input type='checkbox' {...register('hiredOrSupervisedOwnPersonalAssistant')}/>
                                                            Hired or Supevised Own Personal Assistant
                                                        </label>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <label>
                                                            <input type='checkbox' {...register('managedTheirAllowanceBudget')} />
                                                            Managed Their Allowance Budget
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} md={6} lg={8}>
                                                <Row>
                                                    <Col xs={12} md={6}>
                                                        <label htmlFor='repfirstname'>Representative First Name</label>
                                                        <input type='text' id='repfirstname' style={{width: '100%'}} {...register('representativeFirstName')} />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <label htmlFor='replastname'>Representative Last Name</label>
                                                        <input type='text' id='replastname' style={{width: '100%'}} {...register('representativeLastName')} />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <label htmlFor='reprelation'>Representative Relation</label>
                                                        <select id='reprelation' style={{width: '100%',height: '30px'}} {...register('representativeRelation')}>
                                                            <option value=''>--Select Relation--</option>
                                                            {
                                                                relationships.map((item) => (
                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <label htmlFor='repaddress'>Representative Address</label>
                                                        <input type='text' id='repaddress' style={{width: '100%'}} {...register('representativeAddress')}/>
                                                    </Col>
                                                    <Col xs={12} md={4}>
                                                        <label htmlFor='repcity'>Representative City</label>
                                                        <input type='text' id='repcity' style={{width: '100%'}} {...register('representativeCity')}  />
                                                    </Col>
                                                    <Col xs={12} md={4}>
                                                        <label htmlFor='repstate'>Representative State</label>
                                                        <select id='repstate' style={{width: '100%',height: '30px'}} {...register('representativeState')} >
                                                            <option value=''>--Select a State--</option>
                                                            {
                                                                states.map((item) => (
                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </Col>
                                                    <Col xs={12} md={4}>
                                                        <label htmlFor='repzip'>Representative Zip</label>
                                                        <input type='text' id='repzip' style={{width: '100%'}} {...register('representativeZip')} />
                                                    </Col>
                                                    <Col xs={12} md={4}>
                                                        <label htmlFor='repphone'>Representative Phone #</label>
                                                        <input type='text' id='repphone' style={{width: '100%'}} {...register('representativePhone')}  />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={12} className='mt-4'>
                                                <Row>
                                                    <Col xs={12}>
                                                    {
                                                        TargetId
                                                        ?
                                                            <div className='d-flex justify-content-between' key='a'>
                                                                <Button type='button' variant='danger' onClick={deselect}>
                                                                    Cancel
                                                                </Button>
                                                                <Button type='submit' variant='primary' disabled={!isDirty || isSubmitting}>
                                                                    {
                                                                        isSubmitting
                                                                        ?
                                                                            <Spinner animation="border" size="sm" />
                                                                        :
                                                                            <>Save Changes</>
                                                                    }
                                                                </Button>
                                                            </div>
                                                        :
                                                            <div className='d-flex justify-content-end' key='b'>
                                                                <Button type='submit' variant='success' disabled={!isDirty || isSubmitting}>
                                                                    {
                                                                        isSubmitting
                                                                        ?
                                                                            <Spinner animation="border" size="sm" />
                                                                        :
                                                                            <>Add</>
                                                                    }
                                                                </Button>
                                                            </div>
                                                    }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
        </form>
    )
}

export default PdsForm;